import axios from "axios";
import {utilityServicesPath} from "../../Constants";

const restCurrencyUrl = utilityServicesPath + '/organizations/currencies'

export default class CurrencyService {

    static async getAll() {
        return axios.get(restCurrencyUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}